
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import { TranslateResult } from 'vue-i18n';
import { stripTags } from '@root/common/filters/htmlFormater';
import { faTextSize } from '@delfi.lt/fa-kit/icons/modules/classic/light';
import SocialTooltip from '@root/common/components/base/SocialTooltip.vue';
import ArticleInfoGooglePrefered from './ArticleInfoGooglePrefered.vue';

interface Props {
  article: ArticleData;
}

interface Data {
  share: {
    title: string;
    url: string;
  };
}

interface Methods {
  copyLink: (string: string) => void;
  openPrint: () => void;
  showLayer: (text: TranslateResult | string) => void;
  setFontSize: () => void;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  components: {
    SocialTooltip,
    ArticleInfoGooglePrefered,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      share: {
        title: stripTags(this.article.content.title.html),
        url: '',
      },
      faTextSize,
    };
  },
  mounted() {
    const { baseUrl } = this.$channelConfig('meta').base;
    this.share.url = `${baseUrl}/a/${this.article.id}`;
  },
  methods: {
    copyLink(string) {
      this.$event.send('link-click', { name: 'Copy', type: `article-info-social-top'}` });

      let textarea;
      let result;
      try {
        textarea = document.createElement('textarea');
        textarea.setAttribute('readonly', 'true');
        textarea.setAttribute('contenteditable', 'true');
        textarea.style.position = 'fixed'; // prevent scroll from jumping to the bottom when focus is set.
        textarea.value = string;

        document.body.appendChild(textarea);

        textarea.select();

        const range = document.createRange();
        range.selectNodeContents(textarea);

        const sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);

        textarea.setSelectionRange(0, textarea.value.length);
        result = document.execCommand('copy');
        this.showLayer(this.$t(`info_layer.url_copied`));
      } catch (err) {
        result = null;
      } finally {
        if (textarea) {
          document.body.removeChild(textarea);
        }
      }

      // manual copy fallback using prompt
      if (!result) {
        const isMac = navigator.platform.toUpperCase().includes('MAC');
        const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
        result = prompt(`Press ${copyHotkey}`, string);
        if (!result) {
          return false;
        }
      }
      return true;
    },
    openPrint() {
      this.$event.send('link-click', { name: 'Print', type: `article-info-social-top'}` });

      if (window && window.print) {
        window.print();
      }
    },
    showLayer(text) {
      if (!text) {
        return false;
      }
      const $infoLayer = document.createElement('div');
      $infoLayer.innerHTML = '<span>' + text + '</span>';
      $infoLayer.classList.add('info-layer');
      $infoLayer.style.display = 'block';
      document.body.appendChild($infoLayer);
      setTimeout(function () {
        $infoLayer.style.display = 'none';
        $infoLayer.parentNode?.removeChild($infoLayer);
      }, 2000);
    },
    setFontSize() {
      this.$event.send('link-click', { name: this.$t('article.info_decorators.enlarge'), type: `article-info-decorators` });
      this.$emit('set-font-size');
    },
  },
});
